import { window } from '../window.js';
import { HTMLControl } from './html_control.js';

const kUnratedText = 'not rated';

/**
 * Labelled range control.
 */
class RangeControl extends HTMLControl {
  static properties = {
    label: {
      attribute: true,
      set(v) {
        this.labelElement.textContent = `${v}: `;
      },
    },
    min: {
      attribute: true,
      set(v) {
        this.rangeElement.min = v;
      },
    },
    max: {
      attribute: true,
      set(v) {
        this.isMaxInfinite = this.isInfiniteValue(v);
        this.rangeElement.max = this.toRangeValue(v);
      },
    },
    value: {
      attribute: true,
      initialize: true,
      postget(v) {
        return parseFloat(v) || 0;
      },
      get() {
        return this.rangeElement.value;
      },
      set(v) {
        this.setTextValue(v);
        if (v !== undefined) {
          this.rangeElement.value = this.toRangeValue(v);
        }
      },
    },
  };

  get unrated() {
    return this.hasAttribute('unrated');
  }

  initialize() {
    super.initialize();

    this.rangeElement.addEventListener('input', () => {
      this.setTextValue(this.rangeElement.value);
    });

    this.unrateLink.addEventListener('click', () => (this.value = undefined));
  }

  static get markup() {
    return `
<div class='header'>
  <div class='label'></div>
  <div class='value'></div>
</div>
<div class='input-container'>
  <input type='range'>
  <div class='unrate'>
    <span class='link'>Unrate</span>
  </div>
</div>
`;
  }

  toRangeValue(v) {
    return this.isInfiniteValue(v) ? parseInt(v) + 1 : v;
  }

  setTextValue(v) {
    if (v === undefined) {
      this.setAttribute('unrated', 'unrated');
      this.valueElement.textContent = kUnratedText;
      return;
    }
    this.removeAttribute('unrated');

    if (this.isMaxInfinite && v == this.rangeElement.max) {
      v = `${parseInt(v) - 1}+`;
    }
    this.valueElement.textContent = v;
  }

  isInfiniteValue(v) {
    return typeof v == 'string' && v.endsWith('+');
  }

  static selectors = {
    Label: '.label',
    Range: 'input',
    Value: '.value',
    UnrateLink: '.unrate > .link',
  };

  static elements = {
    labelElement: this.selectors.Label,
    rangeElement: this.selectors.Range,
    valueElement: this.selectors.Value,
    unrateLink: this.selectors.UnrateLink,
  };
}

window.customElements.define('range-control', RangeControl);

export { RangeControl };
